import axios from "../api";
export const confirmLoginWithCode = async (email, code) => {
    const res = await axios.post("/auth/confirm-login", {
        email,
        verificationCode: code,
    });
    return res.data;
};
//# sourceMappingURL=confirmCodeLogin.js.map